/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-curly-newline */
import React from "react";

import Fade from "react-awesome-reveal";

// import NotFound from "assets/images/NotFound.png";

import Button from "elements/Button";
import FeaturesTable from "./FeaturesTable";
import LicenseSupportSSO from "./LicenseSuportSSO";

export default function PortfolioDetail({ data }) {
  if (data === null) {
    return (
      <section className="container mx-auto">
        <Fade bottom triggerOnce>
          <div className="flex flex-col w-full justify-center items-center min-h-96">
            <h1 className="text-theme-blue text-7xl text-center mt-10 font-bold">
              404
            </h1>
            <p className="text-theme-blue text-2xl text-center">
              Không tìm thấy trang
            </p>
            <div className="flex justify-center mt-8">
              <Button
                href="/project"
                type="link"
                className="flex h-10 px-5 bg-theme-blue text-white items-center rounded transform transition duration-500 hover:bg-gray-900"
              >
                Quay Lại
              </Button>
            </div>
          </div>
        </Fade>
      </section>
    );
  }

  return (
    <section className="container mx-auto">
      <Fade bottom>
        <Button
          type="link"
          href="/project"
          className="flex w-40 h-8 text-lg items-center ml-6 sm:ml-20 mt-8 font-light text-gray-400 hover:underline"
        >
          <svg
            className="w-5 h-5 text-gray-400 mr-1"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Xem Tất Cả
        </Button>
      </Fade>

      {data.map((item) => (
        <div className="flex flex-col mt-2 justify-center">
          <Fade bottom triggerOnce>
            <h1 className="text-5xl text-theme-blue text-center font-bold">
              {item.title === "Hệ thống xác thực tập trung (NST-SSO)"
                ? "Hệ thống quản lý xác thực tập trung (NST-SSO)"
                : item.title}
            </h1>

            <p className="font-light text-xl text-gray-400 text-center mb-4">
              {item.type}
            </p>
          </Fade>
          <Fade bottom delay={300 * 1} triggerOnce>
            <div className="flex justify-center xl:mb-6">
              <img
                src={
                  item.id === "cms-iot" ? item.imageUrlDetail : item.imageUrl
                }
                alt="Project"
                className="flex w-3/5 sm:w-1/5"
              />
            </div>
          </Fade>
          {item.id === "nst-sso" && (
            <Fade bottom delay={300 * 1} triggerOnce>
              <div className="flex flex-col mt-2 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  Thông tin bản quyền sản phẩm
                </h1>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Hãng: Công ty cổ phần phát triển công nghệ Newtech
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Xuất xứ: Việt Nam
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Mã sản phẩm: NST-SSO
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Software License
                    <ul
                      style={{ listStyleType: "'- '" }}
                      className="pl-6 space-y-2 mt-2"
                    >
                      <li>Part Number: NST-SSO-LIC-ENT</li>
                    </ul>
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    License Support
                    <ul
                      style={{ listStyleType: "'- '" }}
                      className="pl-6 space-y-2 mt-2"
                    >
                      <li>Part Number 12 Month: NST-SSO-LS-STD-12M</li>
                      <li>Part Number 24 Month: NST-SSO-LS-STD-24M</li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  Tính năng sản phẩm
                </h1>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Cho phép người dùng chỉ cần đăng nhập 1 lần duy nhất mà
                    không cần phải đăng nhập nhiều lần với các ứng dụng khác
                    nhau, tối ưu hóa khả năng làm việc của người dùng mà vẫn đảm
                    bảo được khả năng bảo mật.
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Cung cấp các lớp bảo mật bổ sung khi người dùng truy cập,
                    ngoài việc người dùng xác thực bằng mật khẩu thì yêu cầu
                    thêm hai hoặc nhiều phương thức xác thực để xác minh danh
                    tính của người dùng (xác thực đa nhân tố), mục đích để gia
                    cố bảo vệ tài khoản của người dùng.
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Hỗ trợ xác thực đa yếu tố như:
                    <ul
                      style={{ listStyleType: "'- '" }}
                      className="pl-6 space-y-2 mt-2"
                    >
                      <li>
                        Xác thực qua mã OTP (SMS, Email, Google Authentication,
                        Microsoft Authenticator)
                      </li>
                      <li>Mẫu hình</li>
                      <li>Quét vân tay</li>
                      <li>Quét võng mạc</li>
                      <li>Nhận dạng khuôn mặt</li>
                      <li>Nhận dạng giọng nói (AI)</li>
                    </ul>
                  </li>
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Tăng cường hiệu quả quản lý, giúp doanh nghiệp dễ dàng quản
                    lý các tài khoản người dùng và truy vết hoạt động của người
                    dùng
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  Kiến trúc và công nghệ
                </h1>

                <ul className="list-disc pl-6 space-y-2">
                  <li className="font-light text-lg text-gray-400 text-justify ">
                    Kiến trúc gồm các tầng:
                    <ul
                      style={{ listStyleType: "'- '" }}
                      className="pl-6 space-y-2 mt-2"
                    >
                      <li>
                        Tầng trình diễn: là tầng hiển thị, sau khi ứng dụng
                        chuyển hướng sang trang đăng nhập của SSO, hệ thống hiển
                        thị giao diện xác thực tập trung thống nhất cho tất cả
                        các ứng dụng toàn đơn vị.
                      </li>
                      <li>
                        Tầng xử lý nghiệp vụ: bao gồm các module xử lý các
                        nghiệp vụ kiểm tra thông tin người dùng và xác thực của
                        hệ thống SSO, không phụ thuộc vào tầng trình diễn.
                      </li>
                      <li>
                        Tầng xử lý CSDL: các thao tác vào ra và quản lý kết nối
                        CSDL. Độc lập với tầng nghiệp vụ.
                      </li>
                      <li>
                        Ứng dụng chạy được trên các phiên bản hệ điều hành Win,
                        Ubuntu, MacOS. Trình duyệt Firefox hoặc các trình duyệt
                        khác.
                      </li>
                      <li>
                        Hệ thống tương thích trên phiên bản cơ sở dữ liệu.
                      </li>
                      <li>Hệ thống chạy được trên nền tảng phần cứng ảo hóa</li>
                    </ul>
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-16 mb-10 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  Chính sách giá
                </h1>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="font-light text-lg text-gray-400 text-justify">
                    Chỉnh sửa theo yêu cầu: tùy theo yêu cầu thực tế
                  </li>
                </ul>
              </div>

              <p className="font-medium text-xl text-theme-blue text-center">
                📞{" "}
                <a
                  href="/discuss-project"
                  className="cursor-pointer hover:underline hover:text-blue-600 transition-colors duration-200"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    window.location.assign("/discuss-project")
                  }
                  onClick={() => window.location.assign("/discuss-project")}
                >
                  Liên hệ ngay
                </a>{" "}
                để được tư vấn và trải nghiệm phiên bản dùng thử miễn phí!
              </p>
              <LicenseSupportSSO />
            </Fade>
          )}

          {(item.id === "vo-eximbank" ||
            item.id === "vo-nhom-ld" ||
            item.id === "vo-heiniken") && (
            <Fade bottom delay={300 * 1} triggerOnce>
              <div className="flex flex-col mt-2 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  VOffice – Giải pháp văn phòng điện tử toàn diện
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify mb-4">
                  Tăng tốc quy trình – Nâng cao hiệu suất – Tối ưu chi phí
                </p>
                <p className="font-light text-lg text-gray-400 text-justify mb-6">
                  Trong bối cảnh chuyển đổi số ngày càng mạnh mẽ, các doanh
                  nghiệp cần một giải pháp văn phòng điện tử thông minh để quản
                  lý công việc hiệu quả, giảm thiểu giấy tờ và tăng cường sự kết
                  nối giữa các phòng ban. VOffice ra đời với sứ mệnh giúp doanh
                  nghiệp vận hành trơn tru, nâng cao hiệu suất và phát triển bền
                  vững.
                </p>
                <p className="font-light text-lg text-gray-400 text-justify">
                  Với giao diện thân thiện, công nghệ tiên tiến và khả năng tùy
                  chỉnh linh hoạt, VOffice mang đến một hệ sinh thái quản lý
                  hiện đại, đáp ứng mọi nhu cầu vận hành doanh nghiệp từ nhỏ đến
                  lớn.
                </p>
              </div>

              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🚀 Vì sao doanh nghiệp của bạn cần VOffice?
                </h1>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Quản lý công việc thông minh, hiệu quả cao
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Dễ dàng giao việc, phân quyền rõ ràng, theo dõi tiến độ công
                    việc theo thời gian thực
                  </li>
                  <li>
                    Tự động nhắc nhở, cảnh báo khi công việc sắp đến hạn, tránh
                    bỏ sót nhiệm vụ quan trọng
                  </li>
                  <li>
                    Hệ thống báo cáo trực quan giúp lãnh đạo ra quyết định nhanh
                    chóng, chính xác
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Lưu trữ & tìm kiếm tài liệu nhanh chóng, bảo mật tối đa
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Quản lý tài liệu tập trung, phân quyền truy cập theo cấp độ
                  </li>
                  <li>
                    Tìm kiếm tài liệu bằng từ khóa, danh mục hoặc bộ lọc thông
                    minh chỉ trong vài giây
                  </li>
                  <li>
                    Lưu vết lịch sử chỉnh sửa, đảm bảo tính minh bạch và an toàn
                    thông tin
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Ký số & Phê duyệt trực tuyến – Tăng tốc xử lý văn bản
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Duyệt hồ sơ, hợp đồng online, không cần in ấn hay gặp mặt
                    trực tiếp
                  </li>
                  <li>
                    Ký số với tiêu chuẩn bảo mật cao, giúp giao dịch điện tử trở
                    nên an toàn và thuận tiện hơn
                  </li>
                  <li>
                    Rút ngắn thời gian phê duyệt, tăng tốc quy trình làm việc,
                    giảm thiểu thủ tục hành chính
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Quản lý lịch họp & Kết nối nội bộ linh hoạt
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Lên lịch họp, gửi lời mời, tích hợp họp trực tuyến chỉ trong
                    vài cú nhấp chuột
                  </li>
                  <li>
                    Chia sẻ tài liệu, thảo luận, ghi nhận biên bản cuộc họp trực
                    tiếp trên hệ thống
                  </li>
                  <li>
                    Theo dõi và quản lý nhiệm vụ sau cuộc họp, đảm bảo mọi quyết
                    định được thực thi hiệu quả
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Hỗ trợ làm việc từ xa – Tích hợp đa nền tảng
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Hoạt động mượt mà trên máy tính, điện thoại, tablet, giúp
                    làm việc linh hoạt ở bất kỳ đâu
                  </li>
                  <li>
                    Đồng bộ dữ liệu theo thời gian thực, đảm bảo công việc không
                    bị gián đoạn
                  </li>
                  <li>
                    Ứng dụng công nghệ điện toán đám mây, bảo mật cao và dễ dàng
                    mở rộng
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🎯 Lợi ích vượt trội của VOffice đối với doanh nghiệp
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Tăng 50% hiệu suất làm việc nhờ hệ thống tự động hóa quy
                    trình
                  </li>
                  <li>
                    Tiết kiệm 70% thời gian xử lý công việc so với phương thức
                    quản lý truyền thống
                  </li>
                  <li>
                    Cắt giảm 90% giấy tờ, giảm thiểu chi phí in ấn, lưu trữ
                  </li>
                  <li>
                    Giúp doanh nghiệp vận hành trơn tru, kiểm soát chặt chẽ và
                    minh bạch hơn
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  💡 VOffice – Chìa khóa chuyển đổi số thành công cho doanh
                  nghiệp hiện đại!
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify mb-10">
                  Đừng để quy trình cồng kềnh và lạc hậu làm chậm bước tiến của
                  doanh nghiệp bạn. Hãy để VOffice trở thành trợ thủ đắc lực,
                  giúp bạn tối ưu công việc, nâng cao hiệu suất và thúc đẩy sự
                  phát triển bền vững.
                </p>
                <p className="font-medium text-xl text-theme-blue text-center">
                  📞{" "}
                  <a
                    href="/discuss-project"
                    className="cursor-pointer hover:underline hover:text-blue-600 transition-colors duration-200"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      window.location.assign("/discuss-project")
                    }
                    onClick={() => window.location.assign("/discuss-project")}
                  >
                    Liên hệ ngay
                  </a>{" "}
                  để được tư vấn và trải nghiệm phiên bản dùng thử miễn phí!
                </p>
              </div>
            </Fade>
          )}
          {item.id === "bd-binh-phuoc" && (
            <Fade bottom delay={300 * 1} triggerOnce>
              {/* Introduction Section */}
              <div className="flex flex-col mt-2 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3 text-center">
                  Giải pháp Quản lý Câu lạc bộ Bóng đá NewTech
                </h1>
                <p className="font-light text-lg text-gray-400 text-center mb-6">
                  Tối ưu vận hành – Nâng cao hiệu suất – Phát triển bền vững
                </p>
              </div>

              {/* Current Situation and Needs */}
              <div className="flex flex-col mt-8 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  📌 Thực trạng và nhu cầu
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify">
                  Việc quản lý một câu lạc bộ bóng đá không chỉ đơn thuần là
                  theo dõi cầu thủ và huấn luyện viên, mà còn cần quản lý lịch
                  thi đấu, cổ động viên, truyền thông và các sự kiện. Để đáp ứng
                  nhu cầu này, NewTech mang đến một giải pháp toàn diện giúp tự
                  động hóa quy trình, nâng cao hiệu suất và tối ưu chi phí.
                </p>
              </div>

              {/* Solution Introduction */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🎯 Giới thiệu giải pháp
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify mb-6">
                  NewTech cung cấp nền tảng quản lý chuyên nghiệp với các tính
                  năng vượt trội:
                </p>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Quản lý nhân sự và cầu thủ
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Lưu trữ thông tin cá nhân, lịch sử thi đấu, tình trạng sức
                    khỏe, hợp đồng
                  </li>
                  <li>
                    Theo dõi dữ liệu huấn luyện viên, bác sĩ và nhân viên hỗ trợ
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Quản lý cổ động viên
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Lưu trữ thông tin người hâm mộ, thẻ thành viên, lịch sử tham
                    gia sự kiện
                  </li>
                  <li>Hỗ trợ tương tác cá nhân hóa với cổ động viên</li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Quản lý lịch thi đấu và sự kiện
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Cập nhật và thông báo lịch thi đấu, kết quả trận đấu theo
                    thời gian thực
                  </li>
                  <li>
                    Quản lý lịch trình các sự kiện như họp báo, lễ kỷ niệm
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Truyền thông và tin tức
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>Quản lý thông tin sự kiện, cập nhật tin tức đội bóng</li>
                  <li>
                    Cho phép cổ động viên tham gia và tương tác với câu lạc bộ
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  Hỗ trợ đa nền tảng
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Giao diện thân thiện trên máy tính và thiết bị di động
                  </li>
                  <li>Đồng bộ dữ liệu theo thời gian thực, bảo mật cao</li>
                </ul>
              </div>

              {/* Benefits Section */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28 mb-10">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  💡 Lợi ích vượt trội của NewTech
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>Tiết kiệm thời gian quản lý, tăng hiệu suất làm việc</li>
                  <li>Cải thiện sự kết nối giữa CLB và cổ động viên</li>
                  <li>Tối ưu quy trình vận hành, giảm thiểu sai sót</li>
                  <li>Nâng cao tính minh bạch và kiểm soát dữ liệu</li>
                </ul>
              </div>

              {/* Call to Action */}
              <p className="font-medium text-xl text-theme-blue text-center">
                📞{" "}
                <a
                  href="/discuss-project"
                  className="cursor-pointer hover:underline hover:text-blue-600 transition-colors duration-200"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    window.location.assign("/discuss-project")
                  }
                  onClick={() => window.location.assign("/discuss-project")}
                >
                  Liên hệ ngay
                </a>{" "}
                để được tư vấn và trải nghiệm phiên bản dùng thử miễn phí!
              </p>
            </Fade>
          )}
          {item.id === "cms-iot" && (
            <Fade bottom delay={300 * 1} triggerOnce>
              {/* Introduction Section */}
              <div className="flex flex-col mt-2 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3 text-center">
                  CMS-IOT – Giải pháp quản lý thiết bị IoT toàn diện
                </h1>
                <p className="font-light text-lg text-gray-400 text-center mb-6">
                  Giám sát hiệu quả – Tối ưu vận hành – Nâng cao bảo mật
                </p>
              </div>

              {/* Introduction Content */}
              <div className="flex flex-col mt-8 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  📌 Giới thiệu
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify">
                  Trong kỷ nguyên kết nối thông minh, việc giám sát và quản lý
                  thiết bị IoT trở thành yếu tố quan trọng giúp doanh nghiệp vận
                  hành hiệu quả, giảm thiểu rủi ro và tối ưu nguồn lực. CMS-IOT
                  là nền tảng quản lý thiết bị IoT tiên tiến, cung cấp khả năng
                  kiểm soát chặt chẽ, giám sát thời gian thực và tự động hóa quy
                  trình.
                </p>
              </div>

              {/* Key Features */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🎯 Tính năng nổi bật
                </h1>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  1️⃣ Quản lý người dùng và nhóm linh hoạt
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Phân quyền truy cập theo vai trò, đảm bảo an toàn dữ liệu
                  </li>
                  <li>
                    Hỗ trợ quản lý nhóm người dùng và nhóm khách hàng, giúp tổ
                    chức vận hành dễ dàng
                  </li>
                  <li>
                    Theo dõi lịch sử hoạt động của từng người dùng để kiểm soát
                    chặt chẽ hơn
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  2️⃣ Quản lý thiết bị IoT dễ dàng
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Hỗ trợ thêm, xóa, chỉnh sửa, cấu hình thiết bị một cách trực
                    quan
                  </li>
                  <li>
                    Cập nhật trạng thái hoạt động của từng thiết bị theo thời
                    gian thực
                  </li>
                  <li>
                    Hỗ trợ quản lý số lượng lớn thiết bị IoT với hiệu suất cao
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  3️⃣ Giám sát & Cảnh báo thông minh
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Hệ thống tự động gửi cảnh báo khi thiết bị gặp sự cố, lỗi
                    kết nối hoặc hỏng hóc
                  </li>
                  <li>
                    Gửi thông báo theo nhiều kênh (email, SMS, ứng dụng) giúp
                    doanh nghiệp kịp thời xử lý
                  </li>
                  <li>
                    Giảm thiểu rủi ro vận hành nhờ khả năng theo dõi chủ động
                  </li>
                </ul>

                <h2 className="text-2xl text-theme-blue font-semibold mt-6 mb-3">
                  4️⃣ Lưu trữ dữ liệu & Báo cáo trực quan
                </h2>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Ghi log chi tiết hoạt động của từng thiết bị và người dùng
                  </li>
                  <li>
                    Báo cáo thống kê về tình trạng thiết bị giúp doanh nghiệp ra
                    quyết định nhanh chóng
                  </li>
                  <li>
                    Dữ liệu được lưu trữ an toàn, có thể truy xuất khi cần thiết
                  </li>
                </ul>
              </div>

              {/* Benefits Section */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  💡 Lợi ích vượt trội của CMS-IOT đối với doanh nghiệp
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Tăng cường giám sát & kiểm soát hệ thống IoT: Hạn chế lỗi kỹ
                    thuật, giảm thời gian downtime của thiết bị
                  </li>
                  <li>
                    Tối ưu hóa quy trình vận hành: Quản lý hàng loạt thiết bị
                    một cách nhanh chóng, chính xác
                  </li>
                  <li>
                    Tiết kiệm chi phí & nâng cao hiệu suất: Tự động hóa quy
                    trình giúp giảm thiểu nhân lực và chi phí vận hành
                  </li>
                  <li>
                    Bảo mật cao & linh hoạt mở rộng: Dữ liệu được mã hóa, đảm
                    bảo an toàn tuyệt đối, hỗ trợ mở rộng quy mô dễ dàng
                  </li>
                </ul>
              </div>

              {/* Applications */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🌍 Ứng dụng của CMS-IOT
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    <span className="font-semibold">
                      Doanh nghiệp viễn thông & công nghệ:
                    </span>{" "}
                    Giám sát hệ thống thiết bị IoT từ xa, tối ưu vận hành
                  </li>
                  <li>
                    <span className="font-semibold">
                      Nhà máy, khu công nghiệp:
                    </span>{" "}
                    Quản lý thiết bị thông minh, nâng cao hiệu suất sản xuất
                  </li>
                  <li>
                    <span className="font-semibold">
                      Tòa nhà thông minh & đô thị hiện đại:
                    </span>{" "}
                    Theo dõi thiết bị điện, hệ thống an ninh, quản lý năng lượng
                  </li>
                  <li>
                    <span className="font-semibold">
                      Ngành y tế & giáo dục:
                    </span>{" "}
                    Quản lý thiết bị y tế, hệ thống cảm biến, thiết bị giám sát
                    từ xa
                  </li>
                </ul>
              </div>

              {/* Call to Action */}
              <div className="flex flex-col mt-16 mb-16 mx-8 sm:mx-16 xl:mx-28">
                <h2 className="text-2xl text-theme-blue font-semibold text-center mb-10">
                  📢 CMS-IOT – Giải pháp tiên tiến giúp doanh nghiệp chủ động
                  quản lý thiết bị IoT một cách thông minh, hiệu quả và bảo mật!
                </h2>
                <p className="font-medium text-xl text-theme-blue text-center">
                  📞{" "}
                  <a
                    href="/discuss-project"
                    className="cursor-pointer hover:underline hover:text-blue-600"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      window.location.assign("/discuss-project")
                    }
                    onClick={() => window.location.assign("/discuss-project")}
                  >
                    Liên hệ ngay
                  </a>{" "}
                  để nhận tư vấn & trải nghiệm phiên bản dùng thử miễn phí!
                </p>
              </div>
            </Fade>
          )}
          {item.id === "phan-mem-quan-ly-dieu-hanh-dai-hoi-dang" && (
            <Fade bottom delay={300 * 1} triggerOnce>
              {/* Introduction Section */}
              <div className="flex flex-col mt-2 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="font-light text-lg text-gray-400 text-center mb-6">
                  Giải pháp số hỗ trợ công tác tổ chức, điều hành và quản lý
                  thông tin kỳ họp trong khuôn khổ Đại hội
                </h1>
              </div>

              {/* Web Version Features */}
              <div className="flex flex-col mt-8 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-6">
                  💻 Ứng dụng Web - Tính năng nổi bật
                </h1>

                <ul className="list-disc pl-6 space-y-4 ml-4">
                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Phiên họp:</span> Quản lý
                    lịch trình các phiên họp, theo dõi chi tiết từng phiên và
                    cập nhật kịp thời.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Chương trình và thông báo:
                    </span>{" "}
                    Quản lý chương trình làm việc, hỗ trợ điều chỉnh và thông
                    báo nhanh chóng đến đại biểu.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Tài liệu kỳ họp:</span> Lưu
                    trữ, phân loại và phân quyền truy cập tài liệu.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Đại biểu và khách mời:
                    </span>{" "}
                    Quản lý thông tin đại biểu, tình trạng tham dự, danh sách
                    khách mời; gửi và xác nhận thư mời trực tuyến.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Phòng họp:</span> Cấu hình
                    phòng họp, sơ đồ chỗ ngồi và thiết bị hỗ trợ; phân bổ phòng
                    cho từng phiên.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Hình ảnh và truyền thông:
                    </span>{" "}
                    Quản lý hình ảnh, tư liệu liên quan; hỗ trợ trình chiếu và
                    xuất album phục vụ báo cáo.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Dashboard kỳ họp:</span>{" "}
                    Tổng hợp thông tin toàn kỳ họp; hỗ trợ đăng ký vắng mặt,
                    đăng ký phát biểu và biểu đồ quan sát theo từng phiên họp.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Thiết bị điểm danh:</span>{" "}
                    Cho phép quản lý thiết bị điểm danh của cán bộ an ninh theo
                    địa chỉ MAC và IMEI của thiết bị. Cán bộ đại chỉ login được
                    với id/password được cấp và với thiết bị điểm danh đã được
                    gán khai báo.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Thiết bị đăng nhập:</span>{" "}
                    Xem lại thông tin thiết bị đăng nhập của người dùng vào hệ
                    thống, đảm bảo an toàn dữ liệu và minh bạch trong quá trình
                    sử dụng.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Cấu hình vai trò và hệ thống:
                    </span>{" "}
                    Phân quyền sử dụng theo vai trò; tùy chỉnh cấu hình hệ
                    thống, quản lý nhật ký hoạt động.
                  </li>
                </ul>
              </div>

              {/* Mobile App Section */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-6">
                  📱 Ứng dụng Mobile - Tính năng nổi bật
                </h1>
                <ul className="list-disc pl-6 space-y-4 ml-4">
                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Lựa chọn tỉnh/thành:</span>{" "}
                    Người dùng chọn đơn vị tổ chức (tỉnh/thành phố) trước khi
                    đăng nhập, giúp ứng dụng linh hoạt và dùng chung cho nhiều
                    địa phương.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Quản lý lịch họp:</span> Xem
                    lịch theo ngày, tuần; cập nhật kịp thời, tránh bỏ sót sự
                    kiện quan trọng.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Chương trình và thông báo:
                    </span>{" "}
                    Truy cập nhanh chóng chương trình làm việc, nghị quyết,
                    thông cáo báo chí và các thông tin chính thức của Đại hội.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Danh sách đại biểu:</span>{" "}
                    Tra cứu thông tin đại biểu tham dự để thuận tiện kết nối và
                    phối hợp công tác.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Phân chia tổ thảo luận:
                    </span>{" "}
                    Hỗ trợ theo dõi danh sách tổ thảo luận, giúp đại biểu chủ
                    động chuẩn bị và tham gia.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Tài liệu lưu hành:</span>{" "}
                    Cập nhật và truy cập tài liệu, văn kiện, báo cáo một cách
                    tập trung và bảo mật.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Biểu đồ điểm danh:</span>{" "}
                    Theo dõi tỷ lệ tham dự trực quan, minh bạch qua hệ thống
                    biểu đồ.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Phim ảnh và triển lãm:
                    </span>{" "}
                    Xem phim tư liệu, hình ảnh, triển lãm phục vụ Đại hội ngay
                    trong ứng dụng.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">
                      Đăng ký và điều hành phát biểu:
                    </span>{" "}
                    Đại biểu có thể đăng ký phát biểu trực tuyến, hỗ trợ điều
                    hành hiệu quả tại hội trường.
                  </li>

                  <li className="font-light text-lg text-gray-400 text-justify">
                    <span className="font-semibold">Kênh trao đổi nội bộ:</span>{" "}
                    Nền tảng giao tiếp an toàn, nhanh chóng, chỉ dành riêng cho
                    đại biểu tham dự Đại hội.
                  </li>
                </ul>
              </div>
              {/* All features */}
              <div className="flex flex-col mt-16 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-6">
                  Danh sách tính năng
                </h1>
                <FeaturesTable />
              </div>
              {/* Call to Action */}
              <div className="flex flex-col mt-16 mb-8 mx-8 sm:mx-16 xl:mx-28">
                <h2 className="text-2xl text-theme-blue font-semibold text-center mb-10">
                  📢 Giải pháp quản lý kỳ họp toàn diện – Hỗ trợ tổ chức Đại hội
                  chuyên nghiệp, hiệu quả và minh bạch!
                </h2>
                <p className="font-medium text-xl text-theme-blue text-center">
                  📞{" "}
                  <a
                    href="/discuss-project"
                    className="cursor-pointer hover:underline hover:text-blue-600 transition-colors duration-200"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      window.location.assign("/discuss-project")
                    }
                    onClick={() => window.location.assign("/discuss-project")}
                  >
                    Liên hệ ngay
                  </a>{" "}
                  để được tư vấn và báo giá dịch vụ
                </p>
              </div>
            </Fade>
          )}

          {item.id === "he-thong-phan-mem-san-giao-dich-cong-nghe" && (
            <Fade bottom delay={300 * 1} triggerOnce>
              <div className="flex flex-col mt-12 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  📌 Giới thiệu giải pháp
                </h1>
                <p className="font-light text-lg text-gray-400 text-justify">
                  Nền tảng đóng vai trò là công cụ trung tâm hỗ trợ kết nối
                  chuyển giao công nghệ tại TP.HCM và các tỉnh vùng Đông Nam Bộ,
                  có khả năng mở rộng quy mô toàn quốc. Hệ thống không chỉ phục
                  vụ niêm yết và kết nối thông tin mà còn hỗ trợ giao dịch công
                  nghệ an toàn, minh bạch, tích hợp tư vấn chuyên gia, theo dõi
                  toàn bộ vòng đời giao dịch và cung cấp dữ liệu phục vụ công
                  tác quản lý nhà nước về thị trường khoa học và công nghệ.
                </p>
              </div>

              <div className="flex flex-col mt-12 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🎯 Các chức năng chính
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-3">
                  <li>
                    <span className="font-semibold">
                      Niêm yết công nghệ &amp; thiết bị:
                    </span>{" "}
                    Đăng tải công nghệ theo TRL, giải pháp kỹ thuật, sáng chế,
                    thiết bị, phần mềm, dịch vụ hỗ trợ; có quy trình kiểm duyệt,
                    phản hồi và cập nhật hồ sơ; liên kết dữ liệu nhiệm vụ
                    KH&amp;CN, sáng kiến và tài sản trí tuệ.
                  </li>
                  <li>
                    <span className="font-semibold">Tìm kiếm nâng cao:</span>{" "}
                    Tra cứu theo ngành/lĩnh vực ứng dụng, TRL, khu vực địa lý,
                    tổ chức sở hữu, từ khóa kỹ thuật và các tiêu chí mở rộng.
                  </li>
                  <li>
                    <span className="font-semibold">
                      So khớp &amp; đề xuất giao dịch (AI):
                    </span>{" "}
                    Phân tích nhu cầu – nguồn cung; đề xuất công nghệ phù hợp;
                    gợi ý chuyên gia/viện-trường/tổ chức trung gian tham gia tư
                    vấn; đánh giá mức độ sẵn sàng, tiềm năng ứng dụng và cảnh
                    báo rủi ro.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Chatbot AI tư vấn chính sách:
                    </span>{" "}
                    Hỗ trợ doanh nghiệp tra cứu chính sách đổi mới công nghệ, hỗ
                    trợ tài chính và pháp lý chuyển giao.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Quản lý giao dịch công nghệ:
                    </span>{" "}
                    Hỗ trợ chào bán, chào mua, đấu giá và chuyển giao; quản lý
                    trạng thái giao dịch từ đăng ký – xác minh – kết nối –
                    thương thảo – hoàn tất – theo dõi sau chuyển giao.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Quản lý hồ sơ &amp; tài liệu:
                    </span>{" "}
                    Lưu trữ hợp đồng, MOU, NDA, hồ sơ đánh giá công nghệ, định
                    giá tài sản trí tuệ và nhật ký giao dịch.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Xác thực &amp; bảo mật giao dịch:
                    </span>{" "}
                    Định danh tổ chức/doanh nghiệp, xác thực người tham gia;
                    tích hợp chữ ký số, hợp đồng điện tử và nhật ký giao dịch để
                    chống chối bỏ và tăng tính minh bạch.
                  </li>
                  <li>
                    <span className="font-semibold">Blockchain:</span> Lưu vết
                    giao dịch, bảo vệ bản quyền hồ sơ công nghệ, xác minh truy
                    xuất nguồn gốc và lịch sử thay đổi dữ liệu.
                  </li>
                  <li>
                    <span className="font-semibold">Báo cáo &amp; KPI:</span> Tự
                    động tổng hợp chỉ số giao dịch thành công, giá trị giao
                    dịch, số lượng công nghệ đăng tải, người dùng thường xuyên,
                    mức độ hài lòng, hiệu quả theo ngành/địa phương.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Phân tích dữ liệu thị trường &amp; dự báo xu hướng:
                    </span>{" "}
                    Phân tích cung–cầu theo lĩnh vực, thời gian, khu vực; xây
                    dựng dashboard và biểu đồ phục vụ hoạch định chính sách và
                    xúc tiến chuyển giao.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Đánh giá &amp; xếp hạng:
                    </span>{" "}
                    Đánh giá/xếp hạng công nghệ, chuyên gia, tổ chức theo tiêu
                    chí minh bạch; xác thực người đánh giá; tiếp nhận phản hồi
                    và xử lý khiếu nại.
                  </li>
                  <li>
                    <span className="font-semibold">Bản đồ công nghệ:</span>{" "}
                    Trực quan hóa nguồn cung–nhu cầu theo ngành, lĩnh vực, TRL
                    và khu vực địa lý.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Triển lãm trực tuyến (Triển lãm số):
                    </span>{" "}
                    Mô-đun phục vụ Techmart, hội thảo, trình diễn công nghệ trực
                    tuyến và hoạt động xúc tiến/quảng bá.
                  </li>
                  <li>
                    <span className="font-semibold">Đa ngôn ngữ:</span> Quản trị
                    nội dung đa ngôn ngữ, hỗ trợ hiển thị song ngữ/đa ngữ để mở
                    rộng tiếp cận trong nước và quốc tế.
                  </li>
                  <li>
                    <span className="font-semibold">
                      Triển khai Cloud &amp; vận hành đa sàn:
                    </span>{" "}
                    Cho phép vận hành nhiều sàn thành viên (tỉnh/thành), mỗi sàn
                    có tên miền/giao diện riêng, dùng chung CSDL có kiểm soát,
                    bảo đảm liên thông và tiết kiệm đầu tư.
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-12 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  ⚙️ Hệ thống tác nghiệp nội bộ
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Phân quyền chi tiết theo vai trò (tiếp nhận, thẩm định, kết
                    nối, truyền thông, quản trị).
                  </li>
                  <li>
                    Theo dõi tiến độ xử lý giao dịch theo từng bước, từng hồ sơ,
                    từng cán bộ phụ trách.
                  </li>
                  <li>
                    Tích hợp lịch công tác, thông báo nội bộ, phân công nhiệm vụ
                    và nhắc việc.
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-12 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  📊 Nền tảng dữ liệu
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>
                    Cơ sở dữ liệu công nghệ (theo ngành, TRL, SHTT, khả năng ứng
                    dụng).
                  </li>
                  <li>Cơ sở dữ liệu chuyên gia và tổ chức KH&amp;CN.</li>
                  <li>Dữ liệu doanh nghiệp có nhu cầu công nghệ.</li>
                  <li>Dữ liệu tài sản trí tuệ.</li>
                  <li>
                    Dữ liệu thị trường và chính sách khoa học và công nghệ.
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-12 mb-0 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">
                  🚀 Ưu điểm nổi bật của hệ thống
                </h1>
                <ul className="list-disc pl-10 font-light text-lg text-gray-400 text-justify space-y-2">
                  <li>Giao diện thân thiện, hỗ trợ đa thiết bị.</li>
                  <li>Bảo mật cao, khả năng mở rộng và tính sẵn sàng cao.</li>
                  <li>
                    Tích hợp hệ thống quốc gia như IPPlatform, CSDL KH&amp;CN
                    của Bộ KH&amp;CN.
                  </li>
                  <li>
                    Cung cấp đầy đủ tài liệu hướng dẫn, quy trình vận hành và
                    đào tạo chuyển giao.
                  </li>
                </ul>
              </div>

              <div className="flex flex-col mt-16 mb-8 mx-8 sm:mx-16 xl:mx-28">
                <p className="font-medium text-xl text-theme-blue text-center">
                  📞{" "}
                  <a
                    href="/discuss-project"
                    className="cursor-pointer hover:underline hover:text-blue-600 transition-colors duration-200"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      window.location.assign("/discuss-project")
                    }
                    onClick={() => window.location.assign("/discuss-project")}
                  >
                    Liên hệ ngay
                  </a>{" "}
                  để nhận tư vấn và trải nghiệm phiên bản dùng thử miễn phí!
                </p>
              </div>
            </Fade>
          )}
        </div>
      ))}
    </section>
  );
}
